import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { DryMassSource } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import { Guid } from 'Lib/Guid';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, NumericInput, RadioGroup, TextInput, TextOutput } from '../../../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../../../Layout';
import { WorksheetAssociatedTestSection, WorksheetEquipmentDropdown } from '../../../../../Core';
import { WorksheetBalanceFieldSet } from '../../../../../Core/WorksheetEquipment';

let WholePortionWetMassesSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const importedMoistureContentId: Guid = useSelector(
    createWorksheetSelector!('Masses.AssociatedMoistureContent.ImportedTest.Id')
  );
  const dryMassSource: DryMassSource = useSelector(createWorksheetSelector!('Masses.DryMassSource'));

  const dryMassOptions: { label: string; value: DryMassSource }[] = [
    { label: 'Oven drying', value: DryMassSource.Measured },
    { label: 'Wet mass and water content', value: DryMassSource.CalculatedFromMoistureContentAndWetMass },
  ];

  return (
    <>
      <ListFieldSection>
        <Field
          input={<RadioGroup />}
          label="Dry Mass Determined by"
          options={dryMassOptions}
          name="Masses.DryMassSource"
        />
      </ListFieldSection>
      {dryMassSource === DryMassSource.Measured && (
        <NamePrefixModifier appendNamePrefix="Masses.MassMeasurement">
          <ListFieldSection>
            <WorksheetBalanceFieldSet label="Balance" name="Equipment.Balance" />
            <Field input={<WorksheetEquipmentDropdown />} name="Equipment.Oven" label="Oven" equipmentType="oven" />
            <Field input={<TextInput />} name="TareID" label="Tare ID" />
            <Field input={<NumericInput />} name="TareMass" label="Tare Mass" />
            <Field input={<NumericInput />} name="TareAndWetMass" label="Tare and Portion Wet Mass" />
            <Field input={<TextOutput />} name="WetMass" label="Portion Wet Mass" />
          </ListFieldSection>
          <ListFieldSection>
            <WorksheetBalanceFieldSet label="Dry Mass Balance" name="Equipment.DryMassBalance" />
          </ListFieldSection>
          <ListFieldSection>
            <Field input={<NumericInput />} name="TareAndDryMass" label="Tare and Portion Dry Mass" />
            <Field input={<TextOutput />} name="DryMass" label="Portion Dry Mass" />
          </ListFieldSection>
        </NamePrefixModifier>
      )}
      {dryMassSource === DryMassSource.CalculatedFromMoistureContentAndWetMass && (
        <>
          <NamePrefixModifier appendNamePrefix="Masses.MassMeasurement">
            <ListFieldSection>
              <WorksheetBalanceFieldSet label="Balance" name="Equipment.Balance" />
            </ListFieldSection>
            <ListFieldSection>
              <Field input={<NumericInput />} name="TareMass" label="Tare Mass" />
              <Field input={<NumericInput />} name="TareAndWetMass" label="Tare and Portion Wet Mass" />
            </ListFieldSection>
          </NamePrefixModifier>

          <WorksheetAssociatedTestSection
            label="Portion Water Content Determined by"
            name="Masses.AssociatedMoistureContent"
            testType="Moisture Content"
            associatedTestModel={{
              measured: true,
              imported: {
                importedTestResults: (
                  <ListFieldSection>
                    <Field input={<TextOutput />} label="Water Content (%)" name="Masses.MoistureContent" emph />
                  </ListFieldSection>
                ),
                importModel: {
                  Id: importedMoistureContentId,
                },
              },
            }}
          />
          <ListFieldSection>
            <Field input={<TextOutput />} label="Portion Dry Mass" name="Masses.DryMass" />
          </ListFieldSection>
        </>
      )}
    </>
  );
};

WholePortionWetMassesSection = withInjectedProps(WholePortionWetMassesSection);

export { WholePortionWetMassesSection };
export default WholePortionWetMassesSection;
